const ROOT = 'RATE_ENGINE_LIST_';

const actions = {
  LOAD_DATA_REQUEST: `${ROOT}LOAD_DATA_REQUEST`,
  LOAD_DATA_SUCCESS: `${ROOT}LOAD_DATA_SUCCESS`,
  LOAD_DATA_ERROR: `${ROOT}LOAD_DATA_ERROR`,
  CLEAR_STORE: `${ROOT}CLEAR_STORE`,
} as const;

export default actions;
